import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

// template — DWR main grid. 2 colonne (main + aside) responsive.
// > 900px : grid-cols [minmax(0,1fr) clamp(280px,28vw,380px)]
// ≤ 900px : grid-cols 1 (aside collassa, ordine controllato da <Aside>).
// Vedi mockup .main-grid (dev-workspace/mockups/.../project/styles.css righe 203-210, 244-247).

interface MainGridProps {
  main: ReactNode;
  aside?: ReactNode;
  className?: string;
}

export function MainGrid({ main, aside, className }: MainGridProps) {
  return (
    <div
      className={cn(
        'mx-auto grid w-full max-w-[1440px]',
        aside
          ? 'grid-cols-[minmax(0,1fr)_clamp(280px,28vw,380px)] max-[900px]:grid-cols-1'
          : 'grid-cols-1',
        className,
      )}
    >
      <div className="min-w-0 px-[clamp(1rem,4vw,3rem)] py-10 max-[900px]:px-4 max-[900px]:py-5">
        {main}
      </div>
      {aside}
    </div>
  );
}
